module.exports = __webpack_public_path__ + "img/SECRETARIA-DE-HACIENDA.dd1688b7.png";